module.exports = __webpack_public_path__ + "img/center05.24f5dc5c.png";